import React, { useState } from 'react';
import categoryImg from '../images/galleryItems/category.jpg';

// Reusable MarqueeCarousel component
const MarqueeCarousel = ({ items, speed = 40 }) => {
  // speed: pixels per second
  const scrollRef = React.useRef(null);

  // Duplicate items for seamless loop
  const marqueeItems = [...items, ...items];

  return (
    <div
      className="relative overflow-x-hidden w-full"
    >
      {/* Left Scroll Button */}
      {/*
      <button
        className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-blue-800 text-white rounded-full p-2 shadow hover:bg-blue-900 focus:outline-none"
        style={{ opacity: 0.8 }}
        onClick={() => scrollByCard(-1)}
        aria-label="Scroll Left"
      >
        <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>
      */}
      {/* Right Scroll Button */}
      {/*
      <button
        className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-blue-800 text-white rounded-full p-2 shadow hover:bg-blue-900 focus:outline-none"
        style={{ opacity: 0.8 }}
        onClick={() => scrollByCard(1)}
        aria-label="Scroll Right"
      >
        <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>
      */}
      <div
        ref={scrollRef}
        className="flex w-max overflow-x-auto scrollbar-hide"
        style={{
          animation: `marquee ${marqueeItems.length * speed}s linear infinite`,
        }}
      >
        {marqueeItems.map((item, idx) => (
          <div
            key={item.id + '-' + idx}
            className="marquee-card flex-shrink-0 w-72 sm:w-80 md:w-96 mx-2 rounded-xl overflow-hidden shadow-md transition-transform group cursor-pointer flex flex-col items-center justify-center h-64 relative"
            style={{ backgroundImage: `url(${item.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
          >
            <div className="flex flex-col items-center justify-center h-full w-full text-center relative z-10">
              <span className="text-2xl font-bold text-white mb-2 drop-shadow-lg">{item.title}</span>
              <span className="text-base text-white font-normal drop-shadow-lg">{item.description}</span>
            </div>
          </div>
        ))}
      </div>
      {/* Marquee animation keyframes */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Photos' },
    { id: 'campus', name: 'Campus Life' },
    { id: 'events', name: 'School Events' },
    { id: 'sports', name: 'Sports & Activities' },
    { id: 'academics', name: 'Academic Life' }
  ];

  const galleryItems = [
    { id: 1, category: 'campus', title: 'School Building', description: 'Main entrance of our modern campus', image: categoryImg },
    { id: 2, category: 'campus', title: 'Library', description: 'Students studying in our library', image: categoryImg },
    { id: 3, category: 'events', title: 'Graduation Ceremony', description: 'Annual graduation celebration', image: categoryImg },
    { id: 4, category: 'events', title: 'Science Fair', description: 'Students showcasing their projects', image: categoryImg },
    { id: 5, category: 'sports', title: 'Basketball Team', description: 'School basketball team in action', image: categoryImg },
    { id: 6, category: 'sports', title: 'Swimming Pool', description: 'Students during swimming lessons', image: categoryImg },
    { id: 7, category: 'academics', title: 'Science Lab', description: 'Students conducting experiments', image: categoryImg },
    { id: 8, category: 'academics', title: 'Art Class', description: 'Creative expression in art class', image: categoryImg },
    { id: 9, category: 'events', title: 'Cultural Festival', description: 'Annual cultural celebration', image: categoryImg },
    { id: 10, category: 'campus', title: 'Garden', description: 'School garden and greenhouse', image: categoryImg },
    { id: 11, category: 'sports', title: 'Soccer Field', description: 'Students playing soccer', image: categoryImg },
    { id: 12, category: 'academics', title: 'Computer Lab', description: 'Technology education in action', image: categoryImg }
  ];

  const filteredItems = activeCategory === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeCategory);

  return (
    <section id="gallery" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">Gallery</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Explore moments from our vibrant school life, events, and activities</p>
        </div>

        <div className="flex flex-col gap-12">
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {categories.map((cat) => (
              <button
                key={cat.id}
                className={`px-6 py-2 rounded-full font-medium border-2 transition-all ${activeCategory === cat.id ? 'bg-blue-800 text-white border-blue-800' : 'bg-white text-gray-600 border-gray-200 hover:bg-blue-800 hover:text-white hover:border-blue-800'}`}
                onClick={() => setActiveCategory(cat.id)}
              >
                {cat.name}
              </button>
            ))}
          </div>

          {/* Show marquee carousel only for 'All Photos' */}
          {activeCategory === 'all' ? (
            <MarqueeCarousel items={galleryItems} speed={8} />
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
              {filteredItems.map((item) => (
                <div key={item.id} className="relative rounded-xl overflow-hidden shadow-md transition-transform group flex flex-col items-center justify-center h-72" style={{ backgroundImage: `url(${item.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <div className="flex flex-col items-center justify-center h-full w-full text-center relative z-10">
                    <span className="text-2xl font-bold text-white mb-2 drop-shadow-lg">{item.title}</span>
                    <span className="text-base text-white font-normal drop-shadow-lg">{item.description}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Gallery; 